import React, { memo } from 'react'
import { IStop } from 'apps/fleet-planner/types/loads'
import { formatStopFacility } from 'apps/fleet-planner/utils/stops'
import { formatCityState } from 'utils/formatCityState'

interface IFacilityDetailsProps {
  stop?: IStop
  sequence?: number
}

export const FacilityDetails = memo<IFacilityDetailsProps>(({ sequence, stop }) => {
  const { address, facility, stopType } = stop || {}
  const { name: facilityName } = facility || {}
  const {
    addressLine1 = '',
    addressLine2 = '',
    addressee = '',
    locality = '',
    postalCode = '',
    subdivisionCode = '',
  } = address || {}
  const testString = `${stopType}-${sequence}`
  return (
    <div className='mb2'>
      {facilityName || addressee ? (
        <span data-test={`${testString}-facility-name`} className='b body-medium'>
          {facilityName || addressee}
          <br />
        </span>
      ) : (
        <span className='b body-medium' data-test={`${testString}-facility-formatted-stop`}>
          {formatStopFacility(stop)}
          <br />
        </span>
      )}
      {addressLine1 && (
        <span data-test={`${testString}-facility-addressLine1`}>
          {addressLine1}
          <br />
        </span>
      )}
      {addressLine2 && (
        <span data-test={`${testString}-facility-addressLine2`}>
          {addressLine2}
          <br />
        </span>
      )}
      {(locality || subdivisionCode) && (
        <>
          <span data-test={`${testString}-city-state`}>
            {formatCityState(locality, subdivisionCode)}
          </span>
        </>
      )}
      {postalCode && (
        <>
          <span>&nbsp;{postalCode}</span>
          <br />
        </>
      )}
    </div>
  )
})
